import axios from "axios";

import { SET_CONTACT_US_SEND_SUCCEEDED, SET_REPORT_THIS_ISSUE_SEND_SUCCEEDED } from "./types";
import { createAsyncAction } from "./appActions";
import { getApiUrl } from "../helpers/apiUrlHelpers";

export const sendContactUsMessage = createAsyncAction(resolve => contactUsMessage =>
  resolve(async dispatch => {
    await axios.post(`${getApiUrl()}/contact-us`, contactUsMessage);
    dispatch({ type: SET_CONTACT_US_SEND_SUCCEEDED, payload: true });
  })
);

export const reportThisIssue = createAsyncAction(resolve => issue =>
  resolve(async dispatch => {
    await axios.post(`${getApiUrl()}/contact-us`, issue);
    dispatch({ type: SET_REPORT_THIS_ISSUE_SEND_SUCCEEDED, payload: true });
  })
);

export const reinitializeContactUsSendSucceeded = () => ({ type: SET_CONTACT_US_SEND_SUCCEEDED, payload: false });

export const reinitializeReportThisIssueSendSucceeded = () => ({ type: SET_REPORT_THIS_ISSUE_SEND_SUCCEEDED, payload: false });



// WEBPACK FOOTER //
// ./src/actions/contactUsActions.js